import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

const QUESTIONS = [1, 2, 3]

export default function PaywallFaq() {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <h2 className="hw-heading">{t('components.faq.heading')}</h2>

      <div className="hw-card divide-hw-line divide-y">
        {QUESTIONS.map((question) => (
          <Disclosure key={question}>
            <div className="px-4">
              <DisclosureButton className="group text-hw-ink flex w-full items-center justify-between gap-3 py-4 text-left text-[15px] font-semibold">
                {t(`components.faq.title${question}`)}

                <ChevronDownIcon className="text-hw-muted h-5 w-5 shrink-0 transition-transform duration-200 group-data-open:rotate-180" />
              </DisclosureButton>

              <DisclosurePanel
                className="text-hw-muted origin-top pb-4 text-sm leading-relaxed transition duration-200 ease-out data-closed:-translate-y-2 data-closed:opacity-0"
                transition
              >
                {t(`components.faq.text${question}`, {
                  email:
                    import.meta.env.VITE_SUPPORT_EMAIL ??
                    'support@app-studio.ai',
                })}
              </DisclosurePanel>
            </div>
          </Disclosure>
        ))}
      </div>
    </div>
  )
}
